// Auto-extracted "Find your perfect match" seed. Edit via Admin → Fact checker → Local Areas.
import type { FaqPage } from "./faqs";

export interface LocalAreaItem {
  id: string;
  page: FaqPage;
  label: string;
  pickName?: string;
  description: string;
  to: string;
  runnerUp?: { label: string; to: string };
  related?: { label: string; to: string };
  sort_order: number;
}

export const LOCAL_AREAS_SEED: LocalAreaItem[] = [
  {
    "id": "trails-area-1",
    "page": "trails",
    "label": "Best for first-time visitors",
    "pickName": "Razor Point & Beach Trail Loop",
    "description": "1.3 mi loop through twisted Torrey pines with the most photographed cliff views in California.",
    "to": "/trails#razor-point",
    "runnerUp": {
      "label": "Guy Fleming Trail",
      "to": "/trails#guy-fleming"
    },
    "related": {
      "label": "Pair with the beach",
      "to": "/beaches#torrey-pines"
    },
    "sort_order": 12
  },
  {
    "id": "trails-area-2",
    "page": "trails",
    "label": "Best for sunsets",
    "pickName": "Coast Walk Trail",
    "description": "Short bluff path above La Jolla's sea caves — turquoise water, twisted pines, and unbeatable golden-hour color.",
    "to": "/trails#coast-walk",
    "runnerUp": {
      "label": "Sunset Cliffs Coastal Trail",
      "to": "/trails#sunset-cliffs-trail"
    },
    "sort_order": 13
  },
  {
    "id": "trails-area-3",
    "page": "trails",
    "label": "Best with a kid in tow",
    "pickName": "Cottonwood Creek to Moonlight Beach",
    "description": "Easy, shaded creek walk that ends magically at a family-friendly main beach.",
    "to": "/trails#cottonwood-moonlight",
    "runnerUp": {
      "label": "Batiquitos Lagoon",
      "to": "/trails#batiquitos-lagoon"
    },
    "sort_order": 14
  },
  {
    "id": "trails-area-4",
    "page": "trails",
    "label": "Best for tide pools combined",
    "pickName": "La Jolla Shores",
    "description": "Drop down to the sand at low tide for tide pools, then climb back via the beach trail.",
    "to": "/trails#razor-point",
    "related": {
      "label": "Check today's tide",
      "to": "/tides#tide-chart"
    },
    "sort_order": 15
  },
  {
    "id": "trails-area-5",
    "page": "trails",
    "label": "Best for a slot-canyon surprise",
    "pickName": "Annie's Canyon",
    "description": "Narrow, sculpted sandstone slot you squeeze through sideways — feels like southern Utah.",
    "to": "/trails#annies-canyon",
    "related": {
      "label": "Lagoon loop nearby",
      "to": "/trails#san-elijo-lagoon"
    },
    "sort_order": 16
  },
  {
    "id": "trails-area-6",
    "page": "trails",
    "label": "Best for solitude and birds",
    "pickName": "San Elijo Lagoon Loop",
    "description": "Boardwalks, salt marsh, and 300+ recorded bird species — quiet even on weekends.",
    "to": "/trails#san-elijo-lagoon",
    "runnerUp": {
      "label": "Batiquitos Lagoon",
      "to": "/trails#batiquitos-lagoon"
    },
    "sort_order": 17
  },
  {
    "id": "dining-area-1",
    "page": "dining",
    "label": "Best for ocean views",
    "pickName": "George's at the Cove",
    "description": "Rooftop dining straight above La Jolla Cove. Book sunset 2+ weeks ahead.",
    "to": "/dining#georges-at-the-cove",
    "runnerUp": {
      "label": "1500 Ocean",
      "to": "/dining#1500-ocean"
    },
    "related": {
      "label": "Pair with La Jolla Cove",
      "to": "/beaches#la-jolla-cove"
    },
    "sort_order": 24
  },
  {
    "id": "dining-area-2",
    "page": "dining",
    "label": "Best for fish tacos",
    "pickName": "The Fish Market",
    "description": "Fresh-off-the-boat seafood with harbor views — the city's classic introduction to local fish.",
    "to": "/dining#the-fish-market",
    "runnerUp": {
      "label": "Fish 101 (Encinitas)",
      "to": "/dining#fish-101"
    },
    "sort_order": 25
  },
  {
    "id": "dining-area-3",
    "page": "dining",
    "label": "Best for date night",
    "pickName": "Stake Chophouse & Bar",
    "description": "Coronado's premier chophouse — prime steaks, fresh seafood, chic island setting.",
    "to": "/dining#stake-chophouse-and-bar",
    "runnerUp": {
      "label": "Campfire (Carlsbad)",
      "to": "/dining#campfire"
    },
    "related": {
      "label": "Plan a nightcap",
      "to": "/nightlife#raised-by-wolves"
    },
    "sort_order": 26
  },
  {
    "id": "dining-area-4",
    "page": "dining",
    "label": "Best for craft beer + pizza",
    "pickName": "Pizza Port",
    "description": "Iconic North County brewery and pizzeria — award-winning beer with massive slices.",
    "to": "/dining#pizza-port",
    "runnerUp": {
      "label": "Pillbox Tavern",
      "to": "/dining#pillbox-tavern"
    },
    "sort_order": 27
  },
  {
    "id": "dining-area-5",
    "page": "dining",
    "label": "Best for casual oceanfront",
    "pickName": "Jake's Del Mar",
    "description": "Iconic oceanfront seating right on the Del Mar sand — sunsets and timeless California charm.",
    "to": "/dining#jakes-del-mar",
    "runnerUp": {
      "label": "Pacific Coast Grill",
      "to": "/dining#pacific-coast-grill"
    },
    "related": {
      "label": "Walk Del Mar Beach",
      "to": "/beaches#powerhouse-park"
    },
    "sort_order": 28
  },
  {
    "id": "dining-area-6",
    "page": "dining",
    "label": "Best for adventurous eaters",
    "pickName": "Wrench & Rodent Seabasstropub",
    "description": "Creative sushi and sustainable seafood — book the omakase night in advance.",
    "to": "/dining#wrench-and-rodent-seabasstropub",
    "runnerUp": {
      "label": "Coasterra",
      "to": "/dining#coasterra"
    },
    "sort_order": 29
  },
  {
    "id": "nightlife-area-1",
    "page": "nightlife",
    "label": "Best for sunset cocktails",
    "pickName": "Altitude Sky Lounge",
    "description": "San Diego's highest rooftop — 360° skyline and harbor views with handcrafted cocktails.",
    "to": "/nightlife#altitude-sky-lounge",
    "runnerUp": {
      "label": "Marina Kitchen",
      "to": "/nightlife#marina-kitchen"
    },
    "related": {
      "label": "Plan dinner first",
      "to": "/dining#georges-at-the-cove"
    },
    "sort_order": 36
  },
  {
    "id": "nightlife-area-2",
    "page": "nightlife",
    "label": "Best for a hidden speakeasy",
    "pickName": "Noble Experiment",
    "description": "Reservation-only room concealed behind a wall of golden skulls in East Village.",
    "to": "/nightlife#noble-experiment",
    "runnerUp": {
      "label": "Raised by Wolves",
      "to": "/nightlife#raised-by-wolves"
    },
    "sort_order": 37
  },
  {
    "id": "nightlife-area-3",
    "page": "nightlife",
    "label": "Best for live music + beer garden",
    "pickName": "The Observatory",
    "description": "North Park venue blending live music, craft brews, and an outdoor beer garden under string lights.",
    "to": "/nightlife#the-observatory",
    "related": {
      "label": "Find a show",
      "to": "/events#switchfoot-bro-am"
    },
    "sort_order": 38
  },
  {
    "id": "nightlife-area-4",
    "page": "nightlife",
    "label": "Best for a tropical escape",
    "pickName": "Grass Skirt Tiki Room",
    "description": "Flaming cocktails and tiki mugs hidden inside a PB sandwich shop. Reservations help.",
    "to": "/nightlife#grass-skirt-tiki-room",
    "related": {
      "label": "Stay in PB",
      "to": "/beaches#pacific-beach"
    },
    "sort_order": 39
  },
  {
    "id": "nightlife-area-5",
    "page": "nightlife",
    "label": "Best for waterfront wine",
    "pickName": "Marina Kitchen",
    "description": "Sleek harborside lounge with curated wine flights and stunning bay views at sunset.",
    "to": "/nightlife#marina-kitchen",
    "related": {
      "label": "Sunset sail first",
      "to": "/activities#paddleboarding"
    },
    "sort_order": 40
  },
  {
    "id": "nightlife-area-6",
    "page": "nightlife",
    "label": "Best for a beach bonfire",
    "pickName": "Mission Beach fire rings",
    "description": "Claim a ring by 4pm on summer weekends. BYO firewood and water for cleanup.",
    "to": "/beaches#mission-beach",
    "related": {
      "label": "Coronado rings",
      "to": "/beaches#coronado-beach"
    },
    "sort_order": 41
  },
  {
    "id": "surf-area-1",
    "page": "surf",
    "label": "Best for total beginners",
    "pickName": "Tourmaline Surfing Park",
    "description": "Soft, slow waves over a sandy bottom and surf schools right on the sand.",
    "to": "/surf?spot=Tourmaline",
    "runnerUp": {
      "label": "La Jolla Shores",
      "to": "/surf?spot=La Jolla Shores"
    },
    "related": {
      "label": "See the beach",
      "to": "/beaches#tourmaline"
    },
    "sort_order": 48
  },
  {
    "id": "surf-area-2",
    "page": "surf",
    "label": "Best for longboarders",
    "pickName": "Cardiff Reef",
    "description": "Peeling, soft-shouldered right that loves a longboard on a S/SW swell.",
    "to": "/surf?spot=Cardiff Reef",
    "runnerUp": {
      "label": "San Onofre",
      "to": "/surf?spot=San Onofre"
    },
    "related": {
      "label": "Cardiff Reef beach",
      "to": "/beaches#cardiff-reef"
    },
    "sort_order": 49
  },
  {
    "id": "surf-area-3",
    "page": "surf",
    "label": "Best for performance shortboarders",
    "pickName": "Black's Beach",
    "description": "Fast, hollow, and powerful when a clean NW swell wraps in. Strong paddle.",
    "to": "/surf?spot=Black's Beach",
    "runnerUp": {
      "label": "Windansea",
      "to": "/surf?spot=Windansea"
    },
    "related": {
      "label": "Black's beach guide",
      "to": "/beaches#blacks-beach"
    },
    "sort_order": 50
  },
  {
    "id": "surf-area-4",
    "page": "surf",
    "label": "Best for big-wave hunters",
    "pickName": "Black's outer reef",
    "description": "Comes alive on the largest winter swells — read the buoys before paddling out.",
    "to": "/surf?spot=Black's Beach",
    "related": {
      "label": "Check the forecast",
      "to": "/weather#forecast"
    },
    "sort_order": 51
  },
  {
    "id": "surf-area-5",
    "page": "surf",
    "label": "Best when it's onshore everywhere",
    "pickName": "La Jolla Shores",
    "description": "Tucks behind the point and stays surfable when west winds chop up the rest of the coast.",
    "to": "/surf?spot=La Jolla Shores",
    "related": {
      "label": "Beach details",
      "to": "/beaches#la-jolla-cove"
    },
    "sort_order": 52
  },
  {
    "id": "surf-area-6",
    "page": "surf",
    "label": "Best for the family surf trip",
    "pickName": "San Onofre",
    "description": "Gentle, mile-long rides at 'Old Man's' and a family campground above the break.",
    "to": "/surf?spot=San Onofre",
    "related": {
      "label": "Plan an adventure",
      "to": "/activities#surfing"
    },
    "sort_order": 53
  },
  {
    "id": "tides-area-1",
    "page": "tides",
    "label": "Best low tides for tide pools",
    "pickName": "Cabrillo at 0.0 ft or lower",
    "description": "Plan your visit when the chart shows a 0.0 ft (or negative) low — the most marine life is exposed.",
    "to": "/tides#lowest-tide-of-day",
    "related": {
      "label": "Best tide-pool beach",
      "to": "/beaches#sunset-cliffs"
    },
    "sort_order": 60
  },
  {
    "id": "tides-area-2",
    "page": "tides",
    "label": "Best for surf timing",
    "pickName": "Match swell + tide window",
    "description": "Many San Diego reefs only work in a narrow 2-hour tide window — check before you load the car.",
    "to": "/tides#surf-tide-window",
    "related": {
      "label": "Live surf report",
      "to": "/surf#conditions"
    },
    "sort_order": 61
  },
  {
    "id": "tides-area-3",
    "page": "tides",
    "label": "Best for shore fishing",
    "pickName": "Sunrise on a rising tide",
    "description": "Incoming water brings baitfish closer to shore — sunrise on a rising tide is prime time.",
    "to": "/tides#tide-chart",
    "related": {
      "label": "Pier fishing",
      "to": "/beaches#ocean-beach"
    },
    "sort_order": 62
  },
  {
    "id": "tides-area-4",
    "page": "tides",
    "label": "Best for sea cave exploration",
    "pickName": "Falling tide at La Jolla",
    "description": "Cave access opens at minus tides — but only enter on a falling tide for safety.",
    "to": "/tides#lowest-tide-of-day",
    "related": {
      "label": "La Jolla Cove guide",
      "to": "/beaches#la-jolla-cove"
    },
    "sort_order": 63
  },
  {
    "id": "tides-area-5",
    "page": "tides",
    "label": "Best for king tide photography",
    "pickName": "Sunset Cliffs spray show",
    "description": "King-tide highs at Sunset Cliffs turn into a dramatic wave-and-spume display.",
    "to": "/tides#tide-chart",
    "related": {
      "label": "Sunset Cliffs guide",
      "to": "/beaches#sunset-cliffs"
    },
    "sort_order": 64
  },
  {
    "id": "tides-area-6",
    "page": "tides",
    "label": "Best for moon-phase planning",
    "pickName": "Tonight's Moon Tracker",
    "description": "Spring tides cluster around new and full moons — neaps at quarter moons. Plan with the lunar cycle.",
    "to": "/tides#moon-phase",
    "related": {
      "label": "Sunset Cliffs guide",
      "to": "/beaches#sunset-cliffs"
    },
    "sort_order": 65
  },
  {
    "id": "weather-area-1",
    "page": "weather",
    "label": "Best for outdoor weddings",
    "pickName": "Late September forecast",
    "description": "Warm, dry, and almost guaranteed clear skies after Labor Day — the safest outdoor month.",
    "to": "/weather#seasonal-climate",
    "related": {
      "label": "Sunset venue ideas",
      "to": "/dining#georges-at-the-cove"
    },
    "sort_order": 72
  },
  {
    "id": "weather-area-2",
    "page": "weather",
    "label": "Best for whale watching weather",
    "pickName": "Winter clear-air days",
    "description": "Dec–Mar gray-whale season pairs with cool, dry winter air for the clearest offshore visibility.",
    "to": "/weather#marine-forecast",
    "related": {
      "label": "Book a tour",
      "to": "/activities#kayak-sea-caves"
    },
    "sort_order": 73
  },
  {
    "id": "weather-area-3",
    "page": "weather",
    "label": "Best for hiking weather",
    "pickName": "October–May window",
    "description": "Cooler, often crisper air — wildflowers in Feb–Mar after winter rain.",
    "to": "/weather#seasonal-climate",
    "related": {
      "label": "Top trail",
      "to": "/trails#razor-point"
    },
    "sort_order": 74
  },
  {
    "id": "weather-area-4",
    "page": "weather",
    "label": "Best for sunset photography",
    "pickName": "Fall + winter light",
    "description": "Lower sun angle, crisper air, and occasional cloud structure produce the richest sunset colors.",
    "to": "/weather#seasonal-climate",
    "related": {
      "label": "Sunset spot",
      "to": "/beaches#sunset-cliffs"
    },
    "sort_order": 75
  },
  {
    "id": "weather-area-5",
    "page": "weather",
    "label": "Best for warm ocean swims",
    "pickName": "August → early October",
    "description": "Water peaks around 70°F. The 'warm season' is later than people expect.",
    "to": "/weather#marine-forecast",
    "related": {
      "label": "Best swim beach",
      "to": "/beaches#la-jolla-cove"
    },
    "sort_order": 76
  },
  {
    "id": "weather-area-6",
    "page": "weather",
    "label": "Best for clear-day surfing",
    "pickName": "Fall offshore mornings",
    "description": "Offshore winds give glass-clean faces with warm water through October.",
    "to": "/weather#marine-forecast",
    "related": {
      "label": "Live surf report",
      "to": "/surf#conditions"
    },
    "sort_order": 77
  },
  {
    "id": "activities-area-1",
    "page": "activities",
    "label": "Best for beginner surfers",
    "pickName": "Surfing at Pacific Beach",
    "description": "Foam longboards and surf schools every morning — gentle whitewash, sandy bottom, and a forgiving wave to learn on.",
    "to": "/activities#surfing",
    "runnerUp": {
      "label": "La Jolla Shores",
      "to": "/surf?spot=La Jolla Shores#conditions"
    },
    "related": {
      "label": "Live surf report",
      "to": "/surf?spot=La Jolla Shores#conditions"
    },
    "sort_order": 84
  },
  {
    "id": "activities-area-2",
    "page": "activities",
    "label": "Best for marine life",
    "pickName": "Snorkeling at La Jolla Cove",
    "description": "Bright orange Garibaldi, leopard sharks in summer, and resident sea lions a few feet away.",
    "to": "/activities#snorkeling",
    "related": {
      "label": "La Jolla Cove guide",
      "to": "/beaches#la-jolla-cove"
    },
    "sort_order": 85
  },
  {
    "id": "activities-area-3",
    "page": "activities",
    "label": "Best for big air over the coast",
    "pickName": "Paragliding at Torrey Pines",
    "description": "Soar 300 feet above the Pacific from one of the most famous launch sites in the world.",
    "to": "/activities#paragliding",
    "related": {
      "label": "Hike afterward",
      "to": "/trails#razor-point"
    },
    "sort_order": 86
  },
  {
    "id": "activities-area-4",
    "page": "activities",
    "label": "Best for calm-water cruising",
    "pickName": "Paddleboarding Mission Bay",
    "description": "Glide across the largest man-made aquatic park in the country — protected from the open Pacific.",
    "to": "/activities#paddleboarding",
    "related": {
      "label": "Stay nearby",
      "to": "/beaches#mission-beach"
    },
    "sort_order": 87
  },
  {
    "id": "activities-area-5",
    "page": "activities",
    "label": "Best for sea cave paddling",
    "pickName": "Kayak Sea Caves (La Jolla)",
    "description": "Flat water, sea lions and leopard sharks underfoot — 90 minutes that makes everyone smile.",
    "to": "/activities#kayak-sea-caves",
    "related": {
      "label": "Visit La Jolla Cove",
      "to": "/beaches#la-jolla-cove"
    },
    "sort_order": 88
  },
  {
    "id": "activities-area-6",
    "page": "activities",
    "label": "Best for a coastal hike",
    "pickName": "Coastal Hiking at Torrey Pines",
    "description": "Dramatic sandstone trails with rare Torrey pines found nowhere else on Earth.",
    "to": "/activities#coastal-hiking",
    "related": {
      "label": "Trail details",
      "to": "/trails#razor-point"
    },
    "sort_order": 89
  },
  {
    "id": "news-area-1",
    "page": "news",
    "label": "Best for daily safety checks",
    "pickName": "Beach water-quality advisories",
    "description": "Check San Diego County Beach & Bay Status before any swim or surf — especially within 72 hours of rain.",
    "to": "/news#water-quality",
    "runnerUp": {
      "label": "Surfrider chapter",
      "to": "/news#conservation"
    },
    "related": {
      "label": "Beach safety guide",
      "to": "/beaches#la-jolla-cove"
    },
    "sort_order": 96
  },
  {
    "id": "news-area-2",
    "page": "news",
    "label": "Best for conservation news",
    "pickName": "Surfrider San Diego coverage",
    "description": "Kelp restoration, plastic policy, and monthly cleanup events anyone can join.",
    "to": "/news#conservation",
    "runnerUp": {
      "label": "County water quality",
      "to": "/news#water-quality"
    },
    "related": {
      "label": "Volunteer cleanup ideas",
      "to": "/activities#coastal-hiking"
    },
    "sort_order": 97
  },
  {
    "id": "news-area-3",
    "page": "news",
    "label": "Best for marine life updates",
    "pickName": "Whale + leopard shark sightings",
    "description": "Gray whales (Dec–Apr), blues (May–Sep), leopard sharks at the Shores in summer.",
    "to": "/news",
    "related": {
      "label": "Plan a tour",
      "to": "/activities#kayak-sea-caves"
    },
    "sort_order": 98
  },
  {
    "id": "news-area-4",
    "page": "news",
    "label": "Best for beach access updates",
    "pickName": "Sunset Cliffs stairway closures",
    "description": "Bluff erosion regularly closes stairways — check before planning a sunset session.",
    "to": "/news",
    "related": {
      "label": "Sunset Cliffs guide",
      "to": "/beaches#sunset-cliffs"
    },
    "sort_order": 99
  },
  {
    "id": "news-area-5",
    "page": "news",
    "label": "Best for storm impact news",
    "pickName": "King tide damage reports",
    "description": "December–January and June–July king tides — flooding, narrowed beaches, dramatic wave run-up.",
    "to": "/news",
    "related": {
      "label": "Today's tide chart",
      "to": "/tides#tide-chart"
    },
    "sort_order": 100
  },
  {
    "id": "news-area-6",
    "page": "news",
    "label": "Best for surf-industry stories",
    "pickName": "Surfer Magazine feed",
    "description": "Latest from the surf-publication side: gear, contests, and culture pieces.",
    "to": "/news",
    "related": {
      "label": "Live surf report",
      "to": "/surf#conditions"
    },
    "sort_order": 101
  },
  {
    "id": "events-area-1",
    "page": "events",
    "label": "Best for community vibes",
    "pickName": "Carlsbad Village Faire (Fall)",
    "description": "One of the nation's largest single-day street fairs — 800+ vendors, food, and live music in Carlsbad Village.",
    "to": "/events#carlsbad-village-faire-fall",
    "sort_order": 108
  },
  {
    "id": "events-area-2",
    "page": "events",
    "label": "Best for runners",
    "pickName": "La Jolla Half Marathon",
    "description": "Coastal route along bluffs, past Torrey Pines, finishing at the Del Mar Fairgrounds.",
    "to": "/events#la-jolla-half-marathon",
    
    "related": {
      "label": "Coastal trails",
      "to": "/trails#razor-point"
    },
    "sort_order": 109
  },
  {
    "id": "events-area-3",
    "page": "events",
    "label": "Best for fireworks",
    "pickName": "Big Bay Boom",
    "description": "One of the nation's largest shows — four barges across San Diego Bay with synchronized music.",
    "to": "/events#big-bay-boom-fireworks",
    "related": {
      "label": "Best beach view",
      "to": "/beaches#coronado-beach"
    },
    "sort_order": 110
  },
  {
    "id": "events-area-4",
    "page": "events",
    "label": "Best for surf-culture day",
    "pickName": "Switchfoot Bro-Am",
    "description": "Free surf contest and beach concert at Moonlight Beach — raises funds for North County youth.",
    "to": "/events#switchfoot-bro-am",
    "runnerUp": {
      "label": "Oceanside Longboard Contest",
      "to": "/events#oceanside-longboard-surf-contest"
    },
    "related": {
      "label": "Plan a surf session",
      "to": "/surf?spot=Oceanside"
    },
    "sort_order": 111
  },
  {
    "id": "events-area-5",
    "page": "events",
    "label": "Best for film lovers",
    "pickName": "Oceanside International Film Festival",
    "description": "Indie films and shorts from around the world, steps from the Oceanside Pier.",
    "to": "/events#oceanside-international-film-festival",
    "runnerUp": {
      "label": "Surf Film Festival",
      "to": "/events#surf-film-festival"
    },
    "sort_order": 112
  },
  {
    "id": "events-area-6",
    "page": "events",
    "label": "Best for a stylish day out",
    "pickName": "Del Mar Opening Day",
    "description": "'Where the Turf Meets the Surf' — the famous Hats Contest and seaside thoroughbred racing.",
    "to": "/events#del-mar-opening-day",
    "related": {
      "label": "Stay coastal",
      "to": "/beaches#powerhouse-park"
    },
    "sort_order": 113
  }
];
